import {
  createClient as createGraphqlClient,
  type ClientOptions,
} from '@seek/ca-graphql-client';
import { browserHttpLink } from '@seek/ca-graphql-client/browser';

import { createOnErrorLink } from './links';

interface CreateClient {
  webVersion: string;
  graphqlEndpointOverride?: string;
  mockedAuthEnabled?: boolean;
  language: string;
  brand: string;
  country: string;
}

export const createClient = ({
  webVersion,
  graphqlEndpointOverride = '',
  mockedAuthEnabled = false,
  language = 'en',
  brand,
  country,
}: CreateClient) =>
  createGraphqlClient({
    headers: {
      'x-seek-web-version': webVersion,
    },
    appName: 'ca-myjobs-ui',
    httpLink: browserHttpLink,
    links: [createOnErrorLink(language)],
    brand: brand.toLowerCase() as ClientOptions['brand'],
    country: country.toUpperCase() as ClientOptions['country'],
    authOptions: {
      useAuth: true,
      forceStrategy: 'AUTH0',
      ...(mockedAuthEnabled
        ? {
            mockOptions: { authenticated: true },
          }
        : {}),
    },
    ...(graphqlEndpointOverride
      ? {
          graphqlEndpointOverride,
        }
      : {}),
  });
